import * as React from "react";

export const SvgUnseen = (props) => (
	<svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="m3.75 3.125 12.5 13.75M12.102 12.312a3.125 3.125 0 0 1-4.204-4.624"
			stroke={props.color ?? "#A8A8A8"}
			strokeWidth={1.5}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M5.78 5.359C2.597 6.972 1.25 10 1.25 10s2.5 5.624 8.75 5.624a9.22 9.22 0 0 0 4.219-.984M16.298 13.21C18 11.686 18.75 10 18.75 10S16.25 4.374 10 4.374c-.541 0-1.082.043-1.616.132"
			stroke={props.color ?? "#A8A8A8"}
			strokeWidth={1.5}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M10.588 6.93a3.127 3.127 0 0 1 2.523 2.776"
			stroke={props.color ?? "#A8A8A8"}
			strokeWidth={1.5}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
